







































































import { Component, Vue } from 'vue-property-decorator';
import LanguageSwitcher from './language-switcher.vue';
import TopUser from './topUser.vue';
import AppBreadcrumb from './breadcrumb.vue';
import { queryTaskProgress, logout } from '@/utils/api';
@Component({
  components: { LanguageSwitcher, TopUser, AppBreadcrumb },
})
export default class AppNavbar extends Vue {
  $bus: any;
  taskProgressSwitch: any = false;
  taskProgress: any = [];
  loading: boolean = true;
  timer: any = null;
  created() {
    this.$bus.$on('openTask', () => {
      this.onClickTaskProgress();
    });
  }
  tohome() {
    this.$bus.$emit('paths', '/', '/');
  }
  logout() {
    logout().then(res => {
      localStorage.removeItem('authToken')
      location.href = '/login'
    }).catch((error) => {
      this.$message.error('退出失败')
    });
  }
  goPage() {
    this.$router.push({ name: 'list', query: {} });
  }
  createSetInterval() {
    this.timer = setInterval(() => {
      queryTaskProgress().then((res) => {
        this.taskProgress = res;
        this.loading = false;
      });
    }, 2000);
  }
  onClickTaskProgress() {
    this.taskProgressSwitch = true;
    this.createSetInterval();
  }
  onClickDisappear() {
    this.taskProgressSwitch = false;
    clearInterval(this.timer);
  }
}
